import { useEffect, useState } from 'react';

export function useHasLoggedInBefore() {
    const [hasLoggedInBefore, setHasLoggedInBefore] = useState(false);

    useEffect(() => {
        setHasLoggedInBefore(localStorage.getItem('isLoggedIn') === 'true');
    }, []);

    return hasLoggedInBefore;
}
